import React from "react";

import styles from "./Sort.module.scss";
import Dropdown from "../../../UI/Dropdown/Dropdown";

interface SortProps {
  isFilterModalActive: boolean;
  setIsFilterModalActive: (value: boolean) => void;
}

const Sort: React.FC<SortProps> = ({ isFilterModalActive, setIsFilterModalActive }) => {
  const [isInfoShowed, setIsInfoShowed] = React.useState(false);

  return (
    <>
      <div className={styles.body}>
        <div className={styles.title}>
          <h2>Каталог тканей</h2>
          <p className={isInfoShowed ? `${styles.active}` : styles.text} onClick={() => setIsInfoShowed(!isInfoShowed)}>
            100 товаров
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M16.57 7.46539L11.4084 12.6271C10.7988 13.2366 9.80128 13.2366 9.1917 12.6271L4.03003 7.46539"
                stroke="#9D9595"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </p>
        </div>
        <div className={styles.sort}>
          <p>Сортировать</p>
          <Dropdown mode="sortDropdown" />
          <div className={styles.mobileFilter} onClick={() => setIsFilterModalActive(!isFilterModalActive)}>
            <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
              <g clipPath="url(#clip0_54_52)">
                <path
                  d="M0.311954 19.0313C0.311954 10.2075 0.311954 5.79372 3.05284 3.05284C5.79373 0.311951 10.2055 0.311951 19.0313 0.311951C27.8547 0.311951 32.2686 0.311951 35.0094 3.05284C37.7503 5.79372 37.7505 10.2055 37.7505 19.0313C37.7505 27.8547 37.7503 32.2685 35.0094 35.0094C32.2686 37.7503 27.8568 37.7505 19.0313 37.7505C10.2075 37.7505 5.79373 37.7503 3.05284 35.0094C0.311954 32.2685 0.311954 27.8568 0.311954 19.0313Z"
                  stroke="#A7A0A0"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.1347 22.972C11.3508 22.972 10.599 23.2835 10.0447 23.8378C9.4904 24.3921 9.179 25.1438 9.179 25.9278C9.179 26.7116 9.4904 27.4635 10.0447 28.0178C10.599 28.5721 11.3508 28.8834 12.1347 28.8834C12.9186 28.8834 13.6703 28.5721 14.2246 28.0178C14.7789 27.4635 15.0903 26.7116 15.0903 25.9278C15.0903 25.1438 14.7789 24.3921 14.2246 23.8378C13.6703 23.2835 12.9186 22.972 12.1347 22.972ZM12.1347 22.972V9.17902M25.9278 15.0903C25.1438 15.0903 24.3921 14.7789 23.8378 14.2246C23.2835 13.6704 22.972 12.9186 22.972 12.1347C22.972 11.3508 23.2835 10.599 23.8378 10.0447C24.3921 9.49041 25.1438 9.17902 25.9278 9.17902C26.7116 9.17902 27.4635 9.49041 28.0178 10.0447C28.5721 10.599 28.8834 11.3508 28.8834 12.1347C28.8834 12.9186 28.5721 13.6704 28.0178 14.2246C27.4635 14.7789 26.7116 15.0903 25.9278 15.0903ZM25.9278 15.0903V28.8834"
                  stroke="#A7A0A0"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div className={isInfoShowed ? `${styles.info} ${styles.active}` : styles.info}>
        <p>В каталоге сайта вы найдете любые ткани:</p>
        <ul className={styles.catalogOptions}>
          <li>
            <span>Натуральные</span> изготавливаются из волокон растительного или животного происхождения. Они включают в себя
            хлопок, лен, шелк, шерсть и т.д.
          </li>
          <li>
            <span>Синтетические</span> получают из волокон, которые производятся из нефтепродуктов: полиэфира, полиамида. Среди
            них полиэстер, нейлон, акрил и спандекс.
          </li>
          <li>
            <span>Смешанные</span> из натуральных и синтетических волокон — хлопчатобумажные и полиэстерные смеси.
          </li>
          <li>
            <span>Искусственные</span> создаются из целлюлозы или других растительных материалов. В качестве примера можно назвать
            вискозу, модал и лиоцелл.
          </li>
          <li>
            <span>Металлизированные</span> производят методом ионно-плазменного распыления. Специальные нити придают отблеск
            парчовым или жаккардовым тканям.
          </li>
        </ul>
        <p>Вы можете отфильтровать ткани на сайте по:</p>
        <ul className={styles.filterChoices}>
          <li>виду;</li>
          <li>составу;</li>
          <li>плотности;</li>
          <li>рисунку;</li>
          <li>поверхности;</li>
          <li>цвету.</li>
        </ul>
        <p>Ткани доступны для покупки оптом и в розницу напрямую со складов Москвы и Ростова-на-Дону. </p>
        <p>
          Вы можете заказать ткань с собственным дизайном — у нас есть собственное производство печати по тканям. Если у вас нет
          конкретного рисунка или принта, мы разработаем его самостоятельно.
        </p>
        <h3>Скидки и распродажи</h3>
        <p>
          Мы регулярно проводим ликвидацию товара по скидкам -30%, -40% и даже -50%. Акция действует{" "}
          <span>при покупке от метра ткани:</span>
        </p>
        <ul className={styles.textile}>
          <li>вискоза;</li>
          <li>трикотаж;</li>
          <li>кружево;</li>
          <li>плательная ткань;</li>
          <li>креп-сатин.</li>
        </ul>
        <p>
          Сделать подарок вашим близким теперь легко: в магазине «Тканополис» действуют подарочные сертификаты сроком на один год.
          Выберите карточку номиналом в 1000, 3000 или 5000 рублей.{" "}
        </p>
        <p>
          Сертификат не означает бронь товара и не подлежит обмену на денежный эквивалент. Выбрать подарок и расплатиться
          сертификатом можно в физических магазинах в Ростове-на-Дону и Москве, а также при заказе онлайн.{" "}
        </p>
        <h3>Как сделать заказ?</h3>
        <p>
          Добавьте товар в корзину и выберите способ получения товара. Введите персональные данные и ожидайте письма с
          подтверждением заказа на электронной почте. Наш менеджер свяжется с вами и уточнит условия доставки.{" "}
        </p>
        <p>Минимальная сумма покупки онлайн — 1000 рублей.</p>
        <p>
          Наши ткани доставляют Почта России и СДЭК. Вы можете выбрать любую другую транспортную компанию — укажите желаемый
          способ доставки в комментарии к заказу или сообщите о нем менеджеру.
        </p>
      </div>
    </>
  );
};

export default Sort;
